export const CASE_STATUS = ["Open", "In Progress", "Resolved", "Closed"];

export const caseStatusColor = {
  "Open": "bg-warning/15 text-warning border-warning/30",
  "In Progress": "bg-primary/15 text-primary border-primary/30",
  "Resolved": "bg-success/15 text-success border-success/30",
  "Closed": "bg-secondary text-foreground border-border",
};

export const priorityColor = {
  "High": "bg-primary/15 text-primary border-primary/30",
  "Medium": "bg-warning/15 text-warning border-warning/30",
  "Low": "bg-secondary text-muted-foreground border-border",
};

export const money = (n) => "$" + (Number(n) || 0).toLocaleString();
